module.exports = __webpack_public_path__ + "static/img/irole.410ef01.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/wxsjglm/irole.png
// module id = /Y6U
// module chunks = 7